import { render, staticRenderFns } from "./OrderApprove.vue?vue&type=template&id=3a49644c"
import script from "./OrderApprove.vue?vue&type=script&lang=js"
export * from "./OrderApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports